<template>
  <v-layout row justify-center>
    <v-dialog v-model="localShow" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline" :class="headerColor">{{ title }}</v-card-title>

        <v-card-text>
          <v-layout v-if="!hasSlotData" row wrap justify-center>
            <v-flex xs11>{{ text }}</v-flex>
          </v-layout>

          <slot name="body"></slot>
        </v-card-text>

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>

          <v-btn :color="cancelColor" flat @click="close">{{ cancelText }}</v-btn>

          <v-btn :color="confirmColor" flat @click="confirm">{{ confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    // Czy wyświetlać
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // id
    id: {
      type: Number,
      required: false,
      default: undefined
    },
    // Tytuł dialogu
    title: {
      type: String,
      required: true,
      default: undefined
    },
    // Text do wyświetlenia w dialogu
    text: {
      type: String,
      required: true,
      default: undefined
    },
    // Text do anulowania
    cancelText: {
      type: String,
      required: false,
      default: 'Nie'
    },
    // Text do potwierdzenia
    confirmText: {
      type: String,
      required: false,
      default: 'Tak'
    },
    // Szerokość dialogu
    width: {
      type: Number,
      required: false,
      default: 300
    },
    // Kolor
    headerColor: {
      type: String
    },
    // Kolor przycisku anulowania
    cancelColor: {
      type: String,
      required: false,
      default: 'green darken-1'
    },
    // Kolor przycisku potwierdzenia
    confirmColor: {
      type: String,
      required: false,
      default: 'error'
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm', this.id);
      this.close();
    }
  },
  computed: {
    localShow() {
      return this.show;
    },
    hasSlotData() {
      return this.$slots.body;
    }
  }
};
</script>
